module.exports = __webpack_public_path__ + "static/media/app_store_button.06b36b14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/app_store_button.svg
// module id = 181
// module chunks = 0